import React, { useContext } from 'react'
import Group from 'components/utils/Group'
import GeoContext from 'contexts/geoContext'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import HeadlineTrustpilotLogo from './HeadlineTrustpilotLogo'
import { getSVGImageUrl } from 'lib/image/imageUtils'

function HeadlineTrustIndicator() {
  const { currentRegionCode } = useContext(GeoContext)
  const isUK = currentRegionCode === 'GB'

  return (
    <Group direction="horizontal" verticalAlign="center" gap={16} horizontalAlign="center" wrap="wrap">
      {isUK && <Group gap={8} direction="horizontal" verticalAlign="center">
        <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width={17} height={17} alt=""/>
        <BodyTextBlock colour="neutral-two" weight="bold" variant="small" wrap="no-wrap">ATOL protected</BodyTextBlock>
      </Group>
      }
      <Group gap={8} direction="horizontal" verticalAlign="center">
        <GoogleLongLogo width="50" height="17"/>
        <BodyTextBlock colour="neutral-two" variant="small" weight="bold">4.7/5</BodyTextBlock>
      </Group>
      <Group gap={8} direction="horizontal" verticalAlign="center" >
        <HeadlineTrustpilotLogo width="17" height="16" />
        <BodyTextBlock colour="neutral-two" weight="bold" variant="small" wrap="no-wrap">4.8/5</BodyTextBlock>
      </Group>
    </Group>
  )
}

export default HeadlineTrustIndicator
